import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35bbc87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-wrapper" }

import { ref, reactive, computed, watch, PropType, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import TerminalIconName from '@/views/dashboard/_components/terminal-icon-name/terminal-icon-name.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import { BootViewService, BootItem, DetailItem, DetailQueryParams } from '../boot-view/boot-view.service'
import { TableOpt } from '@/components/cmTable/types'
import { formatTimeStamp } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'boot-item-detail-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  baseInfo: {
    type: Object as PropType<BootItem>,
    default: () => ({})
  },
  direction: {
    type: String as PropType<'rtl' | 'ltr' | 'ttb' | 'btt'>,
    default: 'rtl'
  },
  initialTab: {
    type: String as PropType<'optimized-terminal' | 'unoptimized-terminal'>,
    default: 'optimized-terminal'
  }
},
  emits: ['update:modelValue', 'close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emit = __emit

const injector = useReflectiveInjector([BootViewService])
const bootService = injector.get(BootViewService)

const drawerVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const activeState = ref(props.initialTab)
const optimizedTableRef = ref()
const unoptimizedTableRef = ref()

/** 与 `terminal/start-item/list` 的 page、limit 一致 */
const detailPageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const optimizedQueryParams = reactive<DetailQueryParams>({
  autorun_hash: '',
  optimize_type: 1,
  page: 1,
  limit: 20
})

const unoptimizedQueryParams = reactive<DetailQueryParams>({
  autorun_hash: '',
  optimize_type: 2,
  page: 1,
  limit: 20
})

const tableOpt = computed<TableOpt>(() => ({
  path: 'list',
  totalPath: 'total',
  height: '100%',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  showTip: false,
  selection: false,
  usePagination: false,
  hiddenPageTool: false,
  disableScrollLoad: false,
  columns: [
    { prop: 'computer_name', label: t('bootOptimize.computerName'), columnOpt: { width: 180 } },
    { prop: 'user_mark', label: t('bootOptimize.registerUser') },
    { prop: 'ip_address', label: t('bootOptimize.ipAddress') },
    { prop: 'intercept_time', label: t('bootOptimize.interceptTime'), formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') }
  ]
}))

async function fetchOptimizedData(params: any) {
  return bootService.fetchDetailList({
    ...optimizedQueryParams,
    ...params,
    autorun_hash: props.baseInfo?.autorun_hash || '',
    optimize_type: 1
  })
}

async function fetchUnoptimizedData(params: any) {
  return bootService.fetchDetailList({
    ...unoptimizedQueryParams,
    ...params,
    autorun_hash: props.baseInfo?.autorun_hash || '',
    optimize_type: 2
  })
}

function handleTabClick(tab: any) {
  const isOptimized = tab.props.name === 'optimized-terminal'
  if (isOptimized) {
    optimizedQueryParams.page = 1
    nextTick(() => {
      // 滚动加载模式下，需要重置数据并重新加载
      optimizedTableRef.value?.getList()
    })
  } else {
    unoptimizedQueryParams.page = 1
    nextTick(() => {
      // 滚动加载模式下，需要重置数据并重新加载
      unoptimizedTableRef.value?.getList()
    })
  }
}

function handleClose() {
  emit('close')
}

// 监听 initialTab 变化，更新 activeState
watch(() => props.initialTab, (newTab) => {
  activeState.value = newTab
})

// 监听 drawer 打开和 baseInfo 变化，重新加载数据
watch([() => props.modelValue, () => props.baseInfo?.autorun_hash], ([visible, newHash]) => {
  if (visible && newHash) {
    optimizedQueryParams.autorun_hash = newHash
    unoptimizedQueryParams.autorun_hash = newHash
    optimizedQueryParams.page = 1
    unoptimizedQueryParams.page = 1
    activeState.value = props.initialTab

    // 根据 activeState 加载对应 tab 的数据
    // 滚动加载模式下，getList 会自动重置数据
    nextTick(() => {
      if (activeState.value === 'optimized-terminal') {
        optimizedTableRef.value?.getList()
      } else {
        unoptimizedTableRef.value?.getList()
      }
    })
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    size: "70%",
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerVisible).value = $event)),
    direction: __props.direction,
    "before-close": handleClose,
    title: _ctx.$t('bootOptimize.terminalListTitle', { name: __props.baseInfo?.soft_name || '' }),
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tabs, {
          class: "content-adapt",
          modelValue: activeState.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeState).value = $event)),
          onTabClick: handleTabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('bootOptimize.tabOptimized'),
              name: "optimized-terminal"
            }, {
              default: _withCtx(() => [
                _createVNode(CmTable, {
                  ref_key: "optimizedTableRef",
                  ref: optimizedTableRef,
                  tableOpt: tableOpt.value,
                  "page-option": detailPageOption,
                  api: fetchOptimizedData,
                  modelValue: optimizedQueryParams,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((optimizedQueryParams) = $event))
                }, {
                  computer_name: _withCtx(({ row }: { row?: DetailItem }) => [
                    row
                      ? (_openBlock(), _createBlock(TerminalIconName, {
                          key: 0,
                          computer_name: row.computer_name,
                          system_type: row.system_type,
                          login_status: row.login_status
                        }, null, 8, ["computer_name", "system_type", "login_status"]))
                      : _createCommentVNode("", true)
                  ]),
                  ip_address: _withCtx(({ row }: { row?: DetailItem }) => [
                    row
                      ? (_openBlock(), _createBlock(IPColumn, {
                          key: 0,
                          cip: row.client_ip,
                          sip: row.system_ip
                        }, null, 8, ["cip", "sip"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tableOpt", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('bootOptimize.tabUnoptimized'),
              name: "unoptimized-terminal"
            }, {
              default: _withCtx(() => [
                _createVNode(CmTable, {
                  ref_key: "unoptimizedTableRef",
                  ref: unoptimizedTableRef,
                  tableOpt: tableOpt.value,
                  "page-option": detailPageOption,
                  api: fetchUnoptimizedData,
                  modelValue: unoptimizedQueryParams,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unoptimizedQueryParams) = $event))
                }, {
                  computer_name: _withCtx(({ row }: { row?: DetailItem }) => [
                    row
                      ? (_openBlock(), _createBlock(TerminalIconName, {
                          key: 0,
                          computer_name: row.computer_name,
                          system_type: row.system_type,
                          login_status: row.login_status
                        }, null, 8, ["computer_name", "system_type", "login_status"]))
                      : _createCommentVNode("", true)
                  ]),
                  ip_address: _withCtx(({ row }: { row?: DetailItem }) => [
                    row
                      ? (_openBlock(), _createBlock(IPColumn, {
                          key: 0,
                          cip: row.client_ip,
                          sip: row.system_ip
                        }, null, 8, ["cip", "sip"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tableOpt", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "direction", "title"]))
}
}

})